export const questionList = [
	"죽기 전 먹고 싶은 음식은?",
	"멸망 전 까지 하고 싶은 일은?",
	"소울 메이트를 찾았는가?",
	"사랑에 빠졌던 장소가 있는가?",
	"매일 웃고 있는가?",
	"어떤 사람으로 기억되고 싶나요? *묘비명*",
];
